// extracted by mini-css-extract-plugin
export default {"text":"style_text__OV1aE","s":"style_s__TiSaW","l":"style_l__EgNhx","xl":"style_xl__w0JzS","xxl":"style_xxl__8qsmJ","xxxl":"style_xxxl__f8Nbw"};